// useSeo — הגדרת title / meta description / Open Graph / canonical לכל דף.
// תוספתי בלבד: מעדכן תגיות קיימות או יוצר חדשות, לעולם לא מסיר.
// עקבי עם הדפוס שכבר קיים ב-ArticlePage, ונתפס ע"י ה-pre-render (Puppeteer)
// כי כל route נטען טרי ומצולם אחרי הרינדור.
import { useEffect } from "react";

const SITE_ORIGIN = "https://cartax.org";
const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/cartax_logo_v1.png`; // פתרון ביניים — יוחלף בכרטיס 1200x630

export interface SeoOptions {
  title?: string;
  description?: string;
  /** URL מלא לתמונת שיתוף; ברירת מחדל = הלוגו הממותג */
  image?: string;
  /** URL קנוני מלא; ברירת מחדל = SITE_ORIGIN + הנתיב הנוכחי */
  canonical?: string;
  /** 'website' (ברירת מחדל) או 'article' */
  ogType?: string;
}

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSeo({ title, description, image, canonical, ogType = "website" }: SeoOptions) {
  useEffect(() => {
    if (title) {
      document.title = title;
      upsertMeta("property", "og:title", title);
    }
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
    }
    upsertMeta("property", "og:type", ogType);
    upsertMeta("property", "og:image", image || DEFAULT_OG_IMAGE);

    let url = canonical;
    if (!url && typeof window !== "undefined") {
      try {
        url = SITE_ORIGIN + decodeURIComponent(window.location.pathname);
      } catch {
        url = SITE_ORIGIN + window.location.pathname;
      }
    }
    if (url) {
      upsertMeta("property", "og:url", url);
      upsertCanonical(url);
    }
  }, [title, description, image, canonical, ogType]);
}

export default useSeo;
